/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Injectable, EventEmitter } from '@angular/core';
import { User, Notification } from '../model';
import { BehaviorSubject } from 'rxjs';
import { UserProvider } from '../providers';
import { LogService } from 'src/app/services';

@Injectable()
export class UserService {
  notifications = new BehaviorSubject<Notification[]>([]);
  notifications$ = this.notifications.asObservable();

  user = new BehaviorSubject<User>(null);
  user$ = this.user.asObservable();
  userProfilePhoto = new BehaviorSubject<string>(null);
  userProfilePhoto$ = this.userProfilePhoto.asObservable();

  extensionState = new BehaviorSubject<boolean>(true);
  extensionState$ = this.extensionState.asObservable();

  onShowSecurityNotice: EventEmitter<void> = new EventEmitter();

  constructor(
    private userProvider: UserProvider,
    public logService : LogService
    
  ) { }

  init(): void {
    this.getUserProfile();
  }

  private getUserProfile(): void {
    this.userProvider.getMyProfile()
      .subscribe(data => {
        if (data.success) {
          let u = User.parse(data.result);

          this.setUser(u);
          this.notifications.next(u.NOTIFICATIONS);
        }
      }, error => {
        this.logService.error(error);
      });
  }

  setUser(u: User): void {
    this.user.next(u);
    localStorage.setItem('R-CRM-PROFILE', JSON.stringify(u));
  }

  setUserProfilePhoto(p: string): void {
    this.userProfilePhoto.next(p);
  }

  setExtensionState(state: boolean): void {
    this.extensionState.next(state);
  }

  getCurrentUser(): User {
    if (this.user)
      return this.user.getValue();
    else return null;
  }

  isAdmin(): boolean {
    if (this.getCurrentUser().USER_ROLES.length === 0)
      return false;

    for (const r of this.getCurrentUser().USER_ROLES)
      if (r.CODE === 'ROLE_ADMIN')
        return true;

    return false;
  }

  isDataEntryRole(): boolean {
    return this.isRoleExist('ROLE_DATA_ENTRY')
  }

  isCoreAccess(): boolean {
    return this.isRolePrivilegeExist('CORE_ACCESS');
  }


  
  private isRolePrivilegeExist(privilegeName): boolean {
    if (this.getCurrentUser()) {
      if (this.getCurrentUser().USER_ROLES.length === 0)
        return false;

      for (const r of this.getCurrentUser().USER_ROLES)
        if (r.ROLE_PRIVILEGES.length > 0) {
          for (const p of r.ROLE_PRIVILEGES)
            if (p.CODE === privilegeName)
              return true;

        }

    }
    return false;

  }

 private isRoleExist(roleName): boolean {
    if (this.getCurrentUser()) {
      if (this.getCurrentUser().USER_ROLES.length === 0)
        return false;

      for (const r of this.getCurrentUser().USER_ROLES)
        if (r.CODE == roleName)
          return true;
    }
    return false;

  }
}
